module.exports = __webpack_public_path__ + "./img/NovedadesCrear.15d39d17029b175f734238fca83bb58b.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/Help/NovedadesCrear.png
// module id = ./public/img/Help/NovedadesCrear.png
// module chunks = 0